import BaseService from '@/services/BaseService'
import {http} from './config'

class ContatoService extends BaseService {
    constructor(){
        super('/v1/contatos')
    }
    listar(data) {
        return http.get(`/v1/contatos`, {params: data});

        // const queryParams = `id=${data.id ? data.id : ''}
        // &nome=${data.nome ? data.nome : ''}
        // &cpf_cnpj=${data.cpf_cnpj ? data.cpf_cnpj : ''}
        // &tipo=${data.tipo ? data.tipo : ''}
        // &cidade=${data.cidade ? data.cidade : ''}
        // &telefone=${data.telefone ? data.telefone : ''}`
        
        // if (!data.limite) {
        //     return http.get(`/v1/contatos?${queryParams}`);
        // }else{
        //     return http.get(`/v1/contatos?${queryParams}&limit=${data.limite}&page=${data.pagina}`);
        // }
    }

    pesquisarContato(data) {
        return http.get(`/v1/contatos`, {params: data});
        // if (data.todos) {
        // } else {
        //     return http.get(`/v1/contatos?&campo=${data.campo}&valor=${data.valor}`);
        // }
    }

    listarTransportadoras(data){
        return http.get(`/v1/contatos?tipo=TRANSPORTADORA`)
    }

    listarFornecedores(data){
        return http.get(`/v1/contatos?tipo=FORNECEDOR`)
    }

    visualizarPagina(data) {
        if(!data.query.campo && !data.query.valor){
            return http.get(`${data.path}?limit=${data.limite}&page=${data.pagina}`)
        }else{
            return http.get(`${data.path}?limit=${data.limite}&page=${data.pagina}&campo=${data.query.campo}&valor=${data.query.valor}`)
        }
    }
}

export default new ContatoService